import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "../../routes/path";

const breadcrumbPages = {};

function BreadCrumb(props) {
  const { pathname } = useLocation();

  const title = breadcrumbPages[pathname];

  if (!title) return null;

  return (
    //    <!-- breadcrumb-area start -->
    <div className="breadcrumb-area">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb_box text-center">
              <h2 className="breadcrumb-title">{title}</h2>
              {/* <!-- breadcrumb-list start --> */}
              <ul className="breadcrumb-list">
                <li className="breadcrumb-item">
                  <Link to={ROUTES.HOME}>Home</Link>
                </li>
                <li className="breadcrumb-item active">{title}</li>
              </ul>
              {/* <!-- breadcrumb-list end --> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BreadCrumb;
